import themeColorsDesingSystem from "assets/theme/ds-colors";
import { IS_PROD_ENV } from "constants/environment";

export function getColorByEnv(inverted = false) {
  if (inverted ? !IS_PROD_ENV : IS_PROD_ENV) {
    return themeColorsDesingSystem.primary.main;
  } else {
    return themeColorsDesingSystem.secondary.main;
  }
}

export function getActivecolorsByEnv(inverted = false) {
  if (inverted ? !IS_PROD_ENV : IS_PROD_ENV) {
    return themeColorsDesingSystem.primary.active;
  } else {
    return themeColorsDesingSystem.secondary.active;
  }
}
